var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-charts" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("div", { staticClass: "chart-container" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "chart-wrapper" }, [
            _c("canvas", {
              ref: "evolucionChart",
              attrs: { width: "400", height: "200" },
            }),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-lg-6" }, [
        _c("div", { staticClass: "chart-container" }, [
          _vm._m(1),
          _vm._v(" "),
          _c("div", { staticClass: "chart-wrapper" }, [
            _c("canvas", {
              ref: "tipoChart",
              attrs: { width: "300", height: "300" },
            }),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-lg-6" }, [
        _c("div", { staticClass: "chart-container" }, [
          _vm._m(2),
          _vm._v(" "),
          _c("div", { staticClass: "chart-wrapper" }, [
            _c("canvas", {
              ref: "prioridadChart",
              attrs: { width: "300", height: "300" },
            }),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("div", { staticClass: "chart-container" }, [
          _vm._m(3),
          _vm._v(" "),
          _c("div", { staticClass: "chart-wrapper" }, [
            _c("canvas", {
              ref: "satisfaccionTipoChart",
              attrs: { width: "400", height: "200" },
            }),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("div", { staticClass: "chart-container" }, [
          _vm._m(4),
          _vm._v(" "),
          _c("div", { staticClass: "chart-wrapper" }, [
            _c("canvas", {
              ref: "satisfaccionTemaChart",
              attrs: { width: "400", height: "300" },
            }),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("div", { staticClass: "chart-container" }, [
          _vm._m(5),
          _vm._v(" "),
          _c("div", { staticClass: "chart-wrapper" }, [
            _c("canvas", {
              ref: "fuentesChart",
              attrs: { width: "400", height: "300" },
            }),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h5", [
      _c("i", { staticClass: "fal fa-chart-line text-primary" }),
      _vm._v(" Evolución Temporal de Solicitudes"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h5", [
      _c("i", { staticClass: "fal fa-chart-pie text-success" }),
      _vm._v(" Distribución por Tipo de Solicitud"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h5", [
      _c("i", { staticClass: "fal fa-chart-pie text-info" }),
      _vm._v(" Distribución por Prioridad"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h5", [
      _c("i", { staticClass: "fal fa-chart-bar text-success" }),
      _vm._v(" Satisfacción por Tipo de Solicitud"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h5", [
      _c("i", { staticClass: "fal fa-chart-bar text-info" }),
      _vm._v(" Satisfacción por Tema de Solicitud"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h5", [
      _c("i", { staticClass: "fal fa-chart-pie text-primary" }),
      _vm._v(" Comparación de Fuentes de Solicitudes"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }